<template>
  <v-card class="my-4" color="background" tile flat>
    <v-row v-if="subMenus.length > 0">
      <v-col
        cols="6"
        md="3"
        v-for="(menu, index) in subMenus"
        :key="'sub-menu-t-' + index"
      >
        <div v-if="menu.show">
          <div v-if="menu.disabled">
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  class="text-center py-4"
                  :elevation="hover ? 5 : 0"
                  hover
                  v-bind="attrs"
                  v-on="on"
                >
                  <div>
                    <v-icon large :color="menu.disabled ? 'grey' : menu.color">
                      {{ menu.icon }}
                    </v-icon>
                  </div>
                  <div>
                    {{ menu.name }}
                  </div>
                </v-card>
              </template>
              <span>{{ menu.disabledReason }}</span>
            </v-tooltip>
          </div>
          <div v-else>
            <v-hover v-slot="{ hover }">
              <v-card
                class="text-center py-4"
                :elevation="hover ? 5 : 0"
                :disabled="menu.disabled"
                hover
                :to="menu.disabled ? null : `${menu.path}`"
              >
                <div>
                  <v-icon large :color="menu.disabled ? 'grey' : menu.color">
                    {{ menu.icon }}
                  </v-icon>
                </div>
                <div>
                  {{ menu.name }}
                </div>
              </v-card>
            </v-hover>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col v-for="index in 16" cols="12" md="3" :key="`skeleton-${index}`">
        <v-skeleton-loader
          class="mx-auto"
          height="100"
          type="card"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: "LoanDetailSubMenu",
  async created() {
    this.subMenus = await this.$store
      .dispatch("authentication/getSubMenu", this.$route.query.loanNumber)
      .then((resp) => resp.data)
      .catch(() => []);
  },
  data() {
    return {
      subMenus: [],
    };
  },
};
</script>
